import {createApp} from 'vue';
import App from './App.vue';
import router from './router';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import VueLazyload from "vue-lazyload";
import zhLocale from 'element-plus/lib/locale/lang/zh-cn'

// import VConsole from 'vconsole'
// const vConsole = new VConsole()

const app = createApp(App)


// if (process.env.NODE_ENV === "development") {
//     app.use(vConsole)
//     console.info("vconsole-info-测试")
// }

app.use(ElementPlus, {
    locale: zhLocale
})
app.use(VueLazyload)
app.use(router).mount('#app')

zhLocale.el.pagination = {
    goto: '跳至',
    pagesize: '条/页',
    total: `共计 {total} 条`,
    pageClassifier: '页'
}

